// Third party
import { createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// Components
import { IRootState } from './type';
import { reducers } from './reducers';
import { PERSIST_KEYS, STORE_SLICES } from '../../utils';
import { TScenarioUsage } from '../../types';

const initialState: IRootState = {
  scenario_usage: [] as TScenarioUsage[],
};

export const slice = createSlice({
  name: STORE_SLICES.SCENARIO_USAGE_DATA,
  initialState,
  reducers,
});

const scenarioUsageDataActions = slice.actions;

const scenarioUsageDataPersistConfig = {
  key: PERSIST_KEYS.SCENARIO_USAGE_DATA,
  storage,
};

export { scenarioUsageDataActions, initialState };
export default persistReducer(scenarioUsageDataPersistConfig, slice.reducer);
